import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchRuntimeConfig, upsertRuntimeConfig } from "@/services/payout.service";

export const useRuntimeConfig = () =>
  useQuery({
    queryKey: ["runtime-config"],
    queryFn: fetchRuntimeConfig,
  });

export const useUpsertRuntimeConfig = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: upsertRuntimeConfig,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["runtime-config"] }),
  });
};